// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VideoCard-LivePostMetric {
  font-size: 12px;
  line-height: 15px;
}
.VideoCard-LivePostMetric strong {
  display: block;
  font-weight: var(--semi_bold_weight);
  color: var(--gray_dark2);
  line-height: 20px;
  height: 20px;
}
.VideoCard-LivePostMetric span {
  display: block;
  color: var(--gray_dark1);
}`, "",{"version":3,"sources":["webpack://./src/components/VideoCard/components/LivePostMetric/index.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,iBAAA;AACF;AACE;EACE,cAAA;EACA,oCAAA;EACA,wBAAA;EACA,iBAAA;EACA,YAAA;AACJ;AAEE;EACE,cAAA;EACA,wBAAA;AAAJ","sourcesContent":[".VideoCard-LivePostMetric {\n  font-size: 12px;\n  line-height: 15px;\n\n  strong {\n    display: block;\n    font-weight: var(--semi_bold_weight);\n    color: var(--gray_dark2);\n    line-height: 20px;\n    height: 20px;\n  }\n\n  span {\n    display: block;\n    color: var(--gray_dark1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
